// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
});

// Load Events
jQuery(document).on('ready', () => {
  routes.loadEvents();
});



// WEBPACK FOOTER //
// ./scripts/archive.js